<template>
    <div class="required-trophies-notice mt-4">
        <div class="flex items-center gap-2 mb-3">
            <img
                src="/img/icons/icon_course_trophies.png"
                alt="trophies"
                class="required-trophies-header-icon"
            />
            <p class="required-trophies-title m-0">
                For at anmode om dette job skal du have disse trofæer.
            </p>
        </div>

        <div class="required-trophies-list">
            <a
                v-for="trophy in requiredTrophies"
                :key="`required-trophy-${trophy.key}`"
                :href="trophy.courseUrl"
                class="required-trophy-item"
                @click.stop
            >
                <img
                    v-if="trophy.icon"
                    :src="trophy.icon"
                    :alt="trophy.name"
                    class="required-trophy-icon"
                />
                <div v-else class="required-trophy-icon required-trophy-icon-fallback">
                    {{ trophy.name.charAt(0) }}
                </div>

                <span v-if="trophy.isEarned" class="required-trophy-earned" title="Trofae opnaaet">
                    <i class="fa fa-check"></i>
                </span>
            </a>
        </div>

        <p class="required-trophies-help m-0">Klik på et trofæ for at gå til kurset.</p>
    </div>
</template>

<style lang="less" type="text/less" scoped>
.required-trophies-notice {
    background: #f4fbff;
    border: 1px solid #b2e2ff;
    border-radius: 12px;
    padding: 12px;
}

.required-trophies-header-icon {
    width: 32px;
    height: 32px;
    object-fit: contain;
}

.required-trophies-title {
    color: #045f8f;
    font-weight: 700;
    font-size: 14px;
    line-height: 1.3;
}

.required-trophies-list {
    display: grid;
    grid-template-columns: repeat(5, minmax(0, 1fr));
    gap: 10px;
}

@media (max-width: 1024px) {
    .required-trophies-list {
        grid-template-columns: repeat(4, minmax(0, 1fr));
    }
}

@media (max-width: 768px) {
    .required-trophies-list {
        grid-template-columns: repeat(3, minmax(0, 1fr));
    }
}

@media (max-width: 480px) {
    .required-trophies-list {
        grid-template-columns: repeat(2, minmax(0, 1fr));
    }
}

.required-trophy-item {
    display: flex;
    align-items: center;
    justify-content: center;
    border: 1px solid #d4eefc;
    border-radius: 10px;
    padding: 8px;
    background: #fff;
    text-decoration: none;
    color: inherit;
    position: relative;
}

.required-trophy-item:hover {
    border-color: #82c9ef;
    box-shadow: 0 3px 8px rgba(0, 0, 0, 0.06);
}

.required-trophy-icon {
    width: 36px;
    height: 36px;
    object-fit: contain;
    flex-shrink: 0;
}

.required-trophy-icon-fallback {
    border-radius: 9999px;
    background: #e8f7ff;
    color: #0369a1;
    display: flex;
    justify-content: center;
    align-items: center;
    font-weight: 700;
    text-transform: uppercase;
}

.required-trophy-earned {
    position: absolute;
    top: 4px;
    right: 4px;
    width: 20px;
    height: 20px;
    border-radius: 9999px;
    background: #20b052;
    color: #fff;
    font-size: 12px;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    flex-shrink: 0;
}

.required-trophies-help {
    margin-top: 10px;
    color: #0369a1;
    font-size: 12px;
}
</style>

<script type="text/babel">
export default {
    props: {
        requiredTrophies: {
            type: Array,
            default: () => [],
        },
    },
}
</script>
